import { useMemo, useState } from 'react'
import { Translate } from 'react-redux-i18n'
import { useNavigate } from 'react-router'
import { Element } from '../../../../common/html/element'
import { COMPONENTS } from '../../../../routers/constants'

export const SearchResultItem = ({ data }) => {
  const navigate = useNavigate()

  const [isHover, setIsHover] = useState(false)

  const getItemBgColor = useMemo(() => {
    return isHover ? '#F3F3F3' : '#fff'
  }, [isHover])

  const onMouseEnter = () => {
    setIsHover(true)
  }

  const onMouseLeave = () => {
    setIsHover(false)
  }

  const onClickItem = () => {
    navigate(
      `${COMPONENTS.internationalSearch.components.internationalSearchPreview.route}?companyId=${data.companyId}`,
    )
  }

  return (
    <Element
      style={{ backgroundColor: getItemBgColor }}
      className={'dFlex py1 px3 cursorPointer'}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClickItem}
    >
      <Element className="w100">
        <Element className="fw600" style={{ color: '#191D25', fontSize: 12 }}>
          {data.name}
        </Element>
        <Element style={{ color: '#3A414B', marginTop: 4, fontSize: 10 }}>
          <span className="fw600">
            <Translate value="internationalSearch.REGISTRATION_NUMBER" />
          </span>
          &nbsp;
          {data.registrationNumber}
        </Element>
      </Element>
    </Element>
  )
}
